import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Who is Booker for?',
  answer: 'Booker is built for three core groups: artists and bands who book their own shows or tours, venues and promoters who program live events, and agents, managers, or bookers who run rosters and close deals at scale. Each role gets a native workflow surface inside the same platform.'
}, {
  question: 'Can artists and venues both use it?',
  answer: 'Yes. Booker is a two-sided platform. Artists discover and reach out to venues, and venues discover and send offers to artists. Both sides work inside the same deal, contract, and show workflow — so nothing gets lost between inboxes.'
}, {
  question: 'Does Booker replace a booking agent?',
  answer: "No. Booker replaces the spreadsheets, scattered emails, and disconnected tools that booking teams already use. If you have an agent, Booker makes them faster. If you don't, Booker gives you the same operational structure agents use — discovery, outreach, deal tracking, contracts, and show ops."
}, {
  question: 'Can Booker handle contracts and deposits?',
  answer: 'Yes. Booker includes contract templates, clause libraries, e-signature support, deposit tracking, invoice generation, and settlement monitoring. You can generate a contract from any confirmed deal and track payment status through the full lifecycle.'
}, {
  question: 'Can it track band-member availability?',
  answer: "Yes. Booker's lineup system lets you define required and optional roles, track member availability and calendar conflicts, manage substitutes, and lock lineup status before confirming a show. A show isn't truly booked until the band can play it."
}, {
  question: 'Does it have a free plan?',
  answer: 'Yes. The Starter plan is free and includes one profile, up to three active campaigns, basic discovery, and deal tracking. You can upgrade to Pro or Team when you need more volume, outreach automation, contracts, or team collaboration.'
}];
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-border" data-id="element-305">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 text-left group" data-id="element-306">
        <span className="text-base font-medium text-textMain group-hover:text-primary transition-colors pr-4" data-id="element-307">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="shrink-0" data-id="element-308">
          <ChevronDownIcon className="w-5 h-5 text-textMuted" data-id="element-309" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-310">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-311">
            <p className="pb-5 text-sm text-textMuted leading-relaxed max-w-3xl" data-id="element-312">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 border-t border-border" data-id="element-313">
      <div className="max-w-3xl mx-auto px-6" data-id="element-314">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-315">
          Frequently asked questions
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="border-t border-border" data-id="element-316">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-317" />)}
        </motion.div>
      </div>
    </section>;
}